import { StationPageWrapper } from '@app/core/routing/StationPageWrapper';
import { ComposeListPage } from './ComposeListPage';

export function ComposeListStationPage() {
  return (
    <StationPageWrapper>
      <ComposeListPage />
    </StationPageWrapper>
  );
}
